import * as actionType from '../constants'

export const getMedicalNeighborhood = tin => ({
  type: actionType.GET_MEDICAL_NEIGHBORHOOD_REQUEST,
  payload: tin,
})

export const searchMedicalNeighborhood = value => ({
  type: actionType.SEARCH_MEDICAL_NEIGHBORHOOD,
  payload: value,
})

export const resetMedicalNeighborhoodFilters = () => ({
  type: actionType.RESET_MEDICAL_NEIGHBORHOOD_FILTERS,
})

export const filterMedicalNeighborhood = specialty => ({
  type: actionType.FILTER_MEDICAL_NEIGHBORHOOD_BY_SPECIALTY,
  payload: specialty,
})

export const getNeighborhoodProvider = reqObj => ({
  type: actionType.GET_NEIGHBORHOOD_PROVIDER_DETAILS_REQUEST,
  payload: reqObj,
})

export const closeProviderDetail = () => ({
  type: actionType.CLOSE_PROVIDER_DETAIL,
})
